module.exports = __webpack_public_path__ + "395986d88dfed9c3182f0a5d445aa45f.svg";